export default [
    {
      path: "/qspiAAATemplate",
      component: () =>
        import("@/components/page/QSPI/AAA/maintainScore"),
      meta: { title: "查询及维护评分模板版本" },
    },
    {
      
      path: "/maintainGradeTem",
      component: () =>
        import("@/components/page/QSPI/AAA/detail/maintainScoreDetail"),
      meta: { title: "维护评分模板" },
    },
    {
      path: "/qspiAAATask",
      component: () =>
        import("@/components/page/QSPI/AAA/ratingTask"),
      meta: { title: "查询AAA评分任务" },
    },
    {
      path: "/aaaMarkSheet",
      component: () =>
        import("@/components/page/QSPI/AAA/markSheet"),
      meta: { title: "AAA评分表" },
    },
    {
      path: "/sponsormarkSheet",
      component: () =>
        import("@/components/page/QSPI/AAA/abarbeitung"),
      meta: { title: "AAA整改" },
    },
    {
      path: "/initiateGrade",
      component: () =>
        import("@/components/page/QSPI/AAA/initiateScoringTask"),
      meta: { title: "发起AAA评分任务" },
    },
    {
      path: "/qspiAAASummary",
      component: () =>
        import("@/components/page/QSPI/AAA/scoreSummary"),
      meta: { title: "AAA评分汇总" },
    },
  ];
  